import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
    faAddressBook,
    faAlignLeft,
    faAt,
    faBasketShopping,
    faBoxesStacked,
    faChalkboardUser,
    faCity,
    faCloudArrowUp,
    faCogs,
    faCommentSms,
    faEnvelope,
    faFileAlt,
    faGrip,
    faInbox,
    faListCheck,
    faPlug,
    faProjectDiagram,
    faShoppingCart,
    faTags,
    faTh,
    faTimeline,
    faUser,
    faUserGraduate,
    faUserTie,
    faUsers,
    faWrench,
} from '@fortawesome/free-solid-svg-icons';
import { Rights } from 'src/app/models/enums/rights';
import { ViewType } from 'src/app/models/enums/view-type';
import { MemoryService } from 'src/app/services/memory.service';

@Component({
    selector: 'app-application-menu',
    templateUrl: './application-menu.component.html',
    styleUrls: ['./application-menu.component.scss'],
    imports: [MatExpansionModule, MatTooltipModule, RouterLink, NgClass, FaIconComponent]
})
export class ApplicationMenuComponent implements OnInit {
    public ViewType = ViewType;

    public faInbox = faInbox;
    public boxGroupIcon = faBoxesStacked;
    public faAddressBook = faAddressBook;
    public faArticle = faShoppingCart;
    public faDocumentType = faFileAlt;
    public faChannel = faCogs;

    public faWorkflow = faProjectDiagram;
    public faAttribute = faTags;
    public faListLayouts = faTh;
    public faFolderStates = faListCheck;
    public roleIcon = faUserGraduate;
    public faSubscriptions = faBasketShopping;
    public faParameters = faWrench;
    public faCity = faCity;
    public faEmailsTemplates = faEnvelope;
    public faSmsTemplates = faCommentSms;
    public faViews = faChalkboardUser;
    public customertIcon = faUserTie;
    public separatorIcon = faGrip;
    public emailAddressIcon = faAt;
    public faUser = faUser;
    public faUsers = faUsers;
    public faLogs = faAlignLeft;
    public faConnectorLogs = faPlug;
    public apiConfigurationIcon = faCloudArrowUp;
    public folderTrackingCustomizationIcon = faTimeline;

    public displayOrganizationsMenu = false;
    public displayGroupUserMenu = true;
    public displayApplicationMenu = false;
    public displayRoleMenu = true;
    public displayBoxMenu = true;
    public displayCustomerMenu = true;
    public displayArticleMenu = true;
    public displayAttributesMenu = true;
    public displayDocumentTypesMenu = true;
    public displayFolderStatesMenu = true;
    public displayEmailTemplateMenu = true;
    public displaySmsTemplateMenu = true;
    public displayWorkflowsMenu = true;
    public displaychannelsMenu = true;
    public displaySubscriptionsMenu = true;
    public displayParametersMenu = true;
    public displayBoxLayoutsMenu = true;
    public displayWorkflowLayoutsMenu = true;
    public displayViewsMenu = true;
    public displayContactsMenu = true;
    public displayEmailAddressesMenu = false;
    public displayProcessMenu = false;
    public displayCurrentViewsMenuGroup = false;
    public displayApiConfigurationsMenu = false;
    public displayFolderTrackingCustomizationMenu = false;

    @Input()
    isOrganizationSelected: boolean = false;

    @Input()
    isViewSelected: boolean = false;

    @Input()
    viewTypeSelected: ViewType = null;

    @Input()
    isArchivedView: boolean = false;

    /**
     * Indique si l'utilisateur connecté est un SuperAdmin.
     */
    isSuperAdmin: boolean;

    private SuperAdmin: number = 0;
    private Admin: number = 2;
    constructor(
        public router: Router,
        private memoryService: MemoryService
    ) {}

    ngOnInit(): void {
        this.isSuperAdmin = this.memoryService.getConnectedUser().roles.indexOf(this.SuperAdmin) !== -1;
        this.displayOrganizationsMenu =
            this.memoryService.getConnectedUser().hasSomeRight(Rights.OrganizationRead, Rights.OrganizationCreate, Rights.OrganizationEdit, Rights.OrganizationDelete) ||
            this.memoryService.getConnectedUser().roles.indexOf(this.SuperAdmin) !== -1;
        this.displayGroupUserMenu = this.memoryService
            .getConnectedUser()
            .hasSomeRight(Rights.GroupAndUserRead, Rights.GroupAndUserCreate, Rights.GroupAndUserEdit, Rights.GroupAndUserDelete);
        this.displayApplicationMenu = this.memoryService.getConnectedUser().roles.indexOf(this.SuperAdmin) !== -1;
        this.displayRoleMenu = this.memoryService.getConnectedUser().hasSomeRight(Rights.RoleRead, Rights.RoleCreate, Rights.RoleEdit, Rights.RoleDelete);
        this.displayBoxMenu = this.memoryService.getConnectedUser().hasSomeRight(Rights.BoxRead, Rights.BoxCreate, Rights.BoxEdit, Rights.BoxDelete);
        this.displayCustomerMenu = this.memoryService.getConnectedUser().hasSomeRight(Rights.CustomerRead, Rights.CustomerCreate, Rights.CustomerEdit, Rights.CustomerDelete);
        this.displayArticleMenu = this.memoryService.getConnectedUser().hasSomeRight(Rights.ArticleRead, Rights.ArticleCreate, Rights.ArticleEdit, Rights.ArticleDelete);
        this.displayAttributesMenu = this.memoryService.getConnectedUser().hasSomeRight(Rights.AttributRead, Rights.AttributCreate, Rights.AttributEdit, Rights.AttributDelete);
        this.displayDocumentTypesMenu = this.memoryService
            .getConnectedUser()
            .hasSomeRight(Rights.DocumentTypeRead, Rights.DocumentTypeCreate, Rights.DocumentTypeEdit, Rights.DocumentTypeDelete);
        this.displayFolderStatesMenu = this.memoryService
            .getConnectedUser()
            .hasSomeRight(Rights.FolderStateRead, Rights.FolderStateCreate, Rights.FolderStateEdit, Rights.FolderStateDelete);
        this.displayEmailTemplateMenu = this.memoryService
            .getConnectedUser()
            .hasSomeRight(Rights.EmailTemplateRead, Rights.EmailTemplateCreate, Rights.EmailTemplateEdit, Rights.EmailTemplateDelete);
        this.displaySmsTemplateMenu = this.memoryService
            .getConnectedUser()
            .hasSomeRight(Rights.SmsTemplateRead, Rights.SmsTemplateCreate, Rights.SmsTemplateEdit, Rights.SmsTemplateDelete);
        this.displayWorkflowsMenu = this.memoryService
            .getConnectedUser()
            .hasSomeRight(Rights.WorkflowDefinitionRead, Rights.WorkflowDefinitionCreate, Rights.WorkflowDefinitionEdit, Rights.WorkflowDefinitionDelete);
        this.displaychannelsMenu = this.memoryService.getConnectedUser().hasSomeRight(Rights.ProcessRead, Rights.ProcessCreate, Rights.ProcessEdit, Rights.ProcessDelete);
        this.displaySubscriptionsMenu = this.memoryService.getConnectedUser().hasSomeRight(Rights.SubscriptionRead, Rights.SubscriptionEdit);
        this.displayParametersMenu = this.memoryService.getConnectedUser().hasSomeRight(Rights.ParameterRead, Rights.ParameterCreate, Rights.ParameterEdit, Rights.ParameterDelete);
        this.displayBoxLayoutsMenu = this.memoryService
            .getConnectedUser()
            .hasSomeRight(Rights.ListLayoutRead, Rights.ListLayoutCreate, Rights.ListLayoutEdit, Rights.ListLayoutDelete);
        this.displayWorkflowLayoutsMenu = this.memoryService
            .getConnectedUser()
            .hasSomeRight(Rights.ListLayoutRead, Rights.ListLayoutCreate, Rights.ListLayoutEdit, Rights.ListLayoutDelete);
        this.displayViewsMenu = this.memoryService.getConnectedUser().hasSomeRight(Rights.ViewRead, Rights.ViewCreate, Rights.ViewEdit, Rights.ViewDelete);
        this.displayContactsMenu = this.memoryService.getConnectedUser().hasSomeRight(Rights.ContactRead, Rights.ContactCreate, Rights.ContactEdit, Rights.ContactDelete);
        this.displayEmailAddressesMenu = this.memoryService
            .getConnectedUser()
            .hasSomeRight(Rights.EmailAddressRead, Rights.EmailAddressCreate, Rights.EmailAddressEdit, Rights.EmailAddressDelete);
        this.displayProcessMenu = this.memoryService.getConnectedUser().hasSomeRight(Rights.ProcessRead, Rights.ProcessCreate, Rights.ProcessEdit, Rights.ProcessDelete);
        this.displayCurrentViewsMenuGroup = this.memoryService.getConnectedUser().hasRight(Rights.ViewRead);
        this.displayApiConfigurationsMenu = this.memoryService
            .getConnectedUser()
            .hasSomeRight(Rights.ApiConfigurationRead, Rights.ApiConfigurationCreate, Rights.ApiConfigurationEdit, Rights.ApiConfigurationDelete);
        this.displayFolderTrackingCustomizationMenu = this.memoryService.getConnectedUser().hasRight(Rights.CustomizeFolderTracking);
    }
}
